import type { ChecklistItem, PackContract } from './types';

const rows: Array<[string, string, string, string[], boolean, string]> = [
  ['move-item-01','price','총 계약 금액',['총액','합계','견적가'],true,'총 계약 금액이 VAT를 포함해 얼마인지 회신 부탁드려요.'],
  ['move-item-02','price','부가세',['VAT','세금'],true,'부가세가 총액에 포함되는지, 별도라면 금액을 회신 부탁드려요.'],
  ['move-item-03','equipment','사다리차',['스카이','사다리'],true,'출발지와 도착지 사다리차 비용이 각각 포함되는지 확인 부탁드려요.'],
  ['move-item-04','access','계단 작업',['계단비','층수'],true,'엘리베이터를 못 쓰는 경우 계단 작업 금액과 적용 조건을 알려 주세요.'],
  ['move-item-05','access','엘리베이터',['E/V','승강기'],true,'엘리베이터 사용료나 작업비가 포함되는지 확인 부탁드려요.'],
  ['move-item-06','access','주차·운반 거리',['주차','운반 거리','운반거리','장거리 운반','골목'],true,'차량 주차 위치가 멀 때 추가되는 금액과 거리 기준을 알려 주세요.'],
  ['move-item-07','labor','작업 인원',['인부','기사'],false,'작업 인원과 인원이 바뀔 때 추가 금액을 알려 주세요.'],
  ['move-item-08','vehicle','차량',['톤수','대수','트럭'],false,'차량 톤수와 대수, 추가 차량 금액을 확인 부탁드려요.'],
  ['move-item-09','inventory','짐 목록',['물량','가재도구'],true,'현재 견적이 어떤 짐 목록을 기준으로 한 것인지 확인 부탁드려요.'],
  ['move-item-10','inventory','추가 짐 기준',['추가 짐','추가짐','물량 증가','짐 추가'],true,'짐이 늘 때 추가 금액을 계산하는 기준을 알려 주세요.'],
  ['move-item-11','service','포장 범위',['포장','반포장','일반'],false,'포장과 정리 범위가 어디까지 포함되는지 확인 부탁드려요.'],
  ['move-item-12','service','에어컨·벽걸이 분리',['에어컨','벽걸이','탈착','철거'],false,'에어컨과 벽걸이 물품 분리·설치 비용이 포함되는지 알려 주세요.'],
  ['move-item-13','service','폐기물 처리',['버림','수거'],false,'폐기물 수거가 가능한지, 별도라면 금액을 알려 주세요.'],
  ['move-item-14','schedule','이사 날짜·시간',['이사 날짜','이사 시간','작업일','도착시간'],true,'작업 날짜와 시작 예정 시간, 지연 시 연락 방법을 확인 부탁드려요.'],
  ['move-item-15','schedule','지연·대기',['지연','대기','대기료','시간초과'],false,'대기 시간이 생길 때 추가 금액과 기준 시간을 알려 주세요.'],
  ['move-item-16','contract','계약금·잔금',['계약금','잔금','예약금','지급'],true,'계약금과 잔금의 금액, 지급 시점을 확인 부탁드려요.'],
  ['move-item-17','contract','취소·변경 조건',['취소 조건','변경 조건','위약금','날짜변경'],true,'취소나 날짜 변경 때 적용되는 금액과 기한을 알려 주세요.'],
  ['move-item-18','protection','파손·분실 접수',['파손','분실','배상','보험'],false,'파손이나 분실이 생겼을 때 접수 방법과 필요한 자료를 알려 주세요.'],
];

export const movingPack: PackContract = {
  packId: 'moving',
  name: '이사',
  documentName: '이사 견적서',
  anchor: {
    doc: '공정거래위원회 이사화물 표준약관',
    article: '제10035호 (등록 2014-10-01)',
    force: 'advisory',
    appliesTo: '이사화물 운송 계약. 표준약관은 권장 기준이며 개별 계약에 자동 적용되지 않는다',
    url: 'https://easylaw.go.kr/CSP/CnpClsMain.laf?popMenu=ov&csmSeq=666&ccfNo=3&cciNo=2&cnpClsNo=2',
    checkedAt: '2026-08-12',
  },
  providerBranch: false,
  groups: ['price', 'equipment', 'access', 'labor', 'vehicle', 'inventory', 'service', 'schedule', 'contract', 'protection'],
  serviceDayLabels: ['D-7', 'D-1', '이사 당일'],
  checklist: rows.map(([id, group, label, aliases, critical, question]) =>
    ({ id, group, label, aliases, critical, question })) as ChecklistItem[],
  implemented: true,
};
